module.exports = __webpack_public_path__ + "static/media/udeJouge.de2c5328.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/training_thumbnails/locomo/udeJouge.png
// module id = 1709
// module chunks = 1